import React,
{ 
  Component 
}from 'react';

import { Button } from 'reactstrap';

class FixedPlugin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: 'dropdown'
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    if (this.state.classes === 'dropdown') {
      this.setState({ classes: 'dropdown show' });
    } else {
      this.setState({ classes: 'dropdown' });
    }
  }
  render() {
    return (
      <div className='fixed-plugin'>
        <div className={this.state.classes}>
          <div onClick={this.handleClick}>
            <i className='fa fa-cog fa-2x' />
          </div>
          <ul className='dropdown-menu show'>
            <li className='button-container'>
              <Button
                color='warning'
                block
                className='btn-round'
                onClick={(e) => {
                  this.handleClick();
                  window.scrollTo(0, 0);
                }}
              >
                Ir al Inicio
              </Button>
            </li>
            <li className='button-container'>
              <Button
                color='default'
                block
                className='btn-round'
                onClick={(e) => {
                  this.handleClick();
                  window.scrollTo(5000000, 5000000);
                }}
              >
                Ir al final
              </Button>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default FixedPlugin;
